import { Component } from 'react'
import withRouter from '../components/withRouter'
import { API } from 'aws-amplify'
import { CiSettings } from 'react-icons/ci'
import { FaChevronDown, FaRegQuestionCircle, FaRegEnvelope, FaRegIdCard, FaSignature, FaSearch } from 'react-icons/fa'
import { LuLogOut } from 'react-icons/lu'
import { FaBuildingShield, FaArrowLeft } from 'react-icons/fa6'
import { TfiReload } from 'react-icons/tfi'
import { FcApproval, FcCancel } from 'react-icons/fc'
import moment from 'moment'
import Sharing from '../images/datasharing.png'
import Logo from '../images/hit_logo.png'
import './datasharing.css'
import './all.css'


class DataSharing extends Component {
    constructor(props) {
        super(props)
        //Insurers  Payers  Linked Payers
        this.state = {
            menu: 'Insurers',
            search: '',
            common: [],
            payers: [],
            apps: [],
            splash: false,
            bounce: false,
            payer: null,
            isOptOut: false,
            provider: null,
            history: [
            ],
            topMenu: null,
            msg: '',
            displayMsg: false,
            isRefreshing: false,
            concurrent: false
        }
    }
    //['Anthem', 'Aetna', 'Cigna', 'Humana', 'United Healthcare', 'HCSC', 'Kaiser Permanente', 'CVS Health', 'BCBSAL'],
    componentDidMount() {
        if (this.props.isAuthenticated) {
            setTimeout(() => this.setState({ splash: false }), 1000)
            API.get('hit', 'props?prop=payers,common')
                .then(resp => {
                    this.setState({ common: resp.data.filter(d => d.prop === 'common')[0].values, payers: resp.data.filter(d => d.prop === 'payers')[0].values, isOptOut: this.props.user && this.props.user.healthIns && this.props.user.healthIns.provider && this.props.user.healthIns.provider.isOptOut })
                })
                .catch(err =>
                    console.log(err)
                )
        } else {
            this.setState({ splash: false, bounce: true })
            setTimeout(() => {
                this.handleNavigate('login', true)
            }, 3000)
        }
    }

    handleNavigate(page, history) {
        const { search } = this.props
        if (history) this.props.onAddHistory(search.pathname + search.search)
        const { navigate } = this.props
        navigate(`/${page}`)
        //console.log(navigate, `/${page}`)
    }

    handleMenuSelected(menu) {
        this.setState({ menu, topMenu: null })
        this.handleRefresh()
    }

    handleStart() {
        this.setState({ menu: 'Payers', topMenu: null })
    }

    handleChange = event => {
        this.setState({ [event.target.id]: event.target.value, topMenu: null })
    }

    handleCheckChanged(e) {
        this.setState({ [e.target.value]: e.target.checked, topMenu: null })
    }

    handlePayerSelected(payer) {
        this.setState({ payer, topMenu: null })
    }

    handleFetch() {
        if (this.state.payer && this.state.consent) {
            this.setState({ menu: 'Linked Payers', topMenu: null })
        } else this.setState({ topMenu: null })
        API.get('hit', 'user')
            .then(resp => {
                this.setState({
                    history: resp.data && resp.data.healthIns && resp.data.healthIns.p2p ? [...resp.data.healthIns.p2p, {
                        "date": moment().format('lll'),
                        "type": this.state.concurrent ? 'Concurrent' : 'Previous',
                        "payer": this.state.payer,
                        "requestor": "Self",
                        "status": "Data Transfer Initiated",
                        "target": "Self"
                    }] : []
                })
                API.post('hit', 'p2p', { body: { type: this.state.concurrent ? 'Concurrent' : 'Previous', payer: this.state.payer } })
                    .then(resp => {
                        this.setState({ menu: 'Linked Payers', msg: resp.status, displayMsg: true, concurrent: false })
                        setTimeout(() => this.handleRefresh(), 2000)
                    })
                    .catch(err => {
                        this.setState({ msg: err.response && err.response.data && err.response.data.error ? err.response.data.error : err.message, displayMsg: true })
                    })
            })
            .catch(err => {
                if (err.response && err.response.status && err.response.status === 403) {
                    this.handleNavigate('login')
                } else this.setState({ msg: err.response && err.response.data && err.response.data.error ? err.response.data.error : err.message, displayMsg: true })
            })
    }

    handleRefresh() {
        this.setState({ isRefreshing: true })
        API.get('hit', 'user')
            .then(resp => {
                this.setState({
                    history: resp.data && resp.data.healthIns && resp.data.healthIns.p2p ? resp.data.healthIns.p2p : [],
                    apps: resp.data && resp.data.healthIns && resp.data.healthIns.apps ? resp.data.healthIns.apps : [],
                    provider: resp.data && resp.data.healthIns && resp.data.healthIns.provider,
                    consent: (this.state.provider && this.state.provider.consent) || true,
                    isRefreshing: false
                })
                this.props.setUser(resp.data)
            })
            .catch(err => {
                if (err.response && err.response.status && err.response.status === 403) {
                    this.handleNavigate('login')
                } else this.setState({ msg: err.response && err.response.data && err.response.data.error ? err.response.data.error : err.message, displayMsg: true, isRefreshing: false })
            })
    }

    handleCancelApp(app) {
        this.setState({ isRefreshing: true })
        API.put('hit', 'appcancel', { body: { app } })
            .then(resp => {
                this.setState({ msg: resp.status, displayMsg: true, isRefreshing: false })
                setTimeout(() => this.handleRefresh(), 2000)
            })
            .catch(err => {
                if (err.response && err.response.status && err.response.status === 403) {
                    this.handleNavigate('login')
                } else this.setState({ msg: err.response && err.response.data && err.response.data.error ? err.response.data.error : err.message, displayMsg: true, isRefreshing: false })
            })
    }

    handleOptOut() {
        if (this.state.isOptOut) {
            API.put('hit', 'providerconsent', { body: { isOptOut: !(this.props.user && this.props.user.healthIns && this.props.user.healthIns.provider && this.props.user.healthIns.provider.isOptOut) } })
                .then(resp => {
                    this.setState({ msg: resp.status, displayMsg: true, isOptOut: false })
                    setTimeout(() => this.handleRefresh(), 2000)
                })
                .catch(err => {
                    if (err.response && err.response.status && err.response.status === 403) {
                        this.handleNavigate('login')
                    } else this.setState({ msg: err.response && err.response.data && err.response.data.error ? err.response.data.error : err.message, displayMsg: true, isRefreshing: false })
                })
        }
    }

    handleTopMenu(topMenu) {
        if (topMenu === this.state.topMenu) this.setState({ topMenu: null })
        else this.setState({ topMenu })
    }

    handleCloseTopMenu() {
        this.setState({ topMenu: null })
    }

    handleMsgOK() {
        this.setState({ msg: '', displayMsg: false })
    }

    getMessage() {
        return <div className='DS-Confirm'>
            <div className='All-Row All-Text'>{this.state.msg}</div>
            <div className="All-Row All-Flex-Wrap">
                <div className='All-Button All-Button-Save' onClick={() => this.handleMsgOK()}>OK</div>
            </div>
        </div>
    }

    getInsurers() {
        return <div>
            <div style={{ fontWeight: 'bold', fontSize: '11pt' }}>Other Health Insurers</div>
            <div style={{ fontWeight: 'bold', fontSize: '18pt' }}>Sharing My Health Data</div>
            <hr />
            <div className='DS-Flex-Spread'>
                <div style={{ fontSize: '11pt' }}>
                    <p>Do you have previous or concurrent health insurers? We've made it easy for you to securely access your health history from your other insurers - all from your Florida Blue member account! By having them share this information with us, you can:</p>
                    <ul>
                        <li>Access your health history, with a 5 year lookback from the date we process your request in just one location, making it easier for you to talk to your doctor about your health needs.</li>
                        <li>Get recommendations for custom health and wellness programs.</li>
                        <li>Share data with any provider where there exists a treatment relationship.</li>
                        <li>Track your care journey and take charge of your health.</li>
                        <li>Ready? You may request your data exchange below or by speaking with an agent.</li>
                    </ul>
                    <div className='DS-Button' style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => this.handleStart()}>Start Now</div>
                </div>
                <div><img src={Sharing} alt="Data Sharing" /></div>
            </div>
        </div>
    }

    getProvider() {
        return <div>
            <div style={{ fontWeight: 'bold', fontSize: '11pt' }}>Provider Data Exchange</div>
            <div style={{ fontWeight: 'bold', fontSize: '18pt' }}>Sharing My Health Data with Providers</div>
            <hr />
            <div className='DS-Flex-Spread'>
                <div style={{ fontWeight: 'bold', fontSize: '16pt', margin: '10px 0' }}>Consent for Authorization</div>
                <div className='DS-Opt-Icon'>{this.props.user && this.props.user.healthIns && this.props.user.healthIns.provider && this.props.user.healthIns.provider.isOptOut ? <FcCancel /> : <FcApproval />}</div>
            </div>
            <p className='DS-Row DS-Legal'>Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
            </p>
            <div className=''>
                <input value="isOptOut" type="checkbox" checked={this.state.isOptOut} onChange={(event) => this.handleCheckChanged(event)} />
                <span className='DS-CB-Text'>{`I have read and understand the implications of Opting ${this.props.user && this.props.user.healthIns && this.props.user.healthIns.provider && this.props.user.healthIns.provider.isOptOut ? 'In' : 'Out'} of Provider Access Data Exchanges.`}</span>
            </div>
            <div style={{ marginTop: '10px' }}>
                <div className='DS-Button' style={{ marginLeft: '10px', marginBottom: '10px' }} onClick={() => this.handleOptOut()}>Submit</div>
            </div>
        </div>
    }

    getPayers() {
        return <div>
            <div style={{ fontWeight: 'bold', fontSize: '11pt' }}>Other Health Insurers</div>
            <div style={{ fontWeight: 'bold', fontSize: '18pt' }}>Sharing My Health Data</div>
            <hr />
            <div className='DS-Text'>To get started, select one of the most common insurance providers listed below or look for one by using the search bar.</div>
            <div className='DS-Flex'>
                <div className='DS-Search-Icon'><FaSearch /></div>
                <input id='search' className='DS-Search' type='search' placeholder='Search for insurance provider' value={this.state.search} onChange={this.handleChange} />
            </div>
            <div style={{ fontWeight: 'bold', fontSize: '16pt', margin: '10px 0' }}>Commonly Used</div>
            {!this.state.search.length > 0 && <div className='DS-Flex-Wrap'>
                {this.state.common.map((c, cidx) => {
                    return <div key={`common-${cidx}`} className={`DS-Payer${this.state.payer === c ? ' DS-Payer-Selected' : ''}`} onClick={() => this.handlePayerSelected(c)}>{c}</div>
                })}
            </div>}
            {this.state.search.length > 0 && <div className='DS-Flex-Wrap'>
                {this.state.payers.filter(payer => payer.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1).sort((a, b) => {
                    if (a > b) return 1
                    if (a < b) return -1
                    return 0
                }).map((p, pidx) => {
                    return <div key={`payer-${pidx}`} className={`DS-Payer${this.state.payer === p ? ' DS-Payer-Selected' : ''}`} onClick={() => this.handlePayerSelected(p)}>{p}</div>
                })}
            </div>}
            <div className=''>
                <input value="concurrent" type="checkbox" checked={this.state.concurrent} onChange={(event) => this.handleCheckChanged(event)} />
                <span className='DS-CB-Text'>I have a concurrent plan and would like quarterly updates to my record.</span>
            </div>
            <hr />
            <div style={{ fontWeight: 'bold', fontSize: '16pt', margin: '10px 0' }}>Next Steps</div>
            <div className='DS-Text'>
                <ol>
                    <li>{`Check the box below to confirm your consent for Random Payer to connect to ${this.state.payer || 'your other payer.'}`}</li>
                    <li>{`After clicking the "Continue" button, Florida Blue will present your authorization to ${this.state.payer || 'your other payer'} and will attempt to retrieve your records.`}</li>
                    <li>Once your data is retrieved, Random Payer will add your data to your clinical history.</li>
                </ol>
            </div>
            <div style={{ fontWeight: 'bold', fontSize: '16pt', margin: '10px 0' }}>Consent for Authorization</div>
            <p className='DS-Row DS-Legal'>Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
                Consent language should go here. Consent language should go here. Consent language should go here.
            </p>
            <div className=''>
                <input value="provider" type="checkbox" checked={this.state.provider} onChange={(event) => this.handleCheckChanged(event)} />
                <span className='DS-CB-Text'>I have read and agree to the Priacy & Consent terms for payer data exchange.</span>
            </div>
            <div className='DS-Button' style={{ marginTop: '10px', marginBottom: '10px' }} onClick={() => this.handleFetch()}>Continue</div>
        </div>
    }

    getLinkedInsurance() {
        return <div>
            <div style={{ fontWeight: 'bold', fontSize: '11pt' }}>3rd Party Data Sharing</div>
            <div style={{ fontWeight: 'bold', fontSize: '18pt' }}>My Linked Insurance Providers</div>
            <hr />
            <div className='DS-Text DS-Flex-Spread'><div>Here is a list of the previous and concurrent insurance providers with data sharing requests.</div><div className={`DS-Refresh${this.state.isRefreshing ? ' All-Spin' : ''}`} onClick={() => this.handleRefresh()}><TfiReload /></div></div>
            <div className='DS-Row DS-Table-Header DS-Flex'>
                <div style={{ width: '170px', padding: '5px' }}>Insurer</div>
                <div style={{ width: '120px', padding: '5px' }}>Payer Type</div>
                <div style={{ width: '280px', padding: '5px' }}>Status</div>
                <div style={{ width: '200px', padding: '5px' }}>Date</div>
            </div>
            {this.state.history.map((h, hidx) => {
                return <div key={`hist-${hidx}`} className='DS-Row DS-Table-Row DS-Flex'>
                    <div style={{ width: '170px', padding: '5px' }}>{h.payer}</div>
                    <div style={{ width: '120px', padding: '5px' }}>{h.type}</div>
                    <div style={{ width: '280px', padding: '5px' }}>{h.status}</div>
                    <div style={{ width: '200px', padding: '5px' }}>{moment(h.date).format('lll')}</div>
                </div>
            })}
        </div>
    }

    getApps() {
        return <div>
            <div style={{ fontWeight: 'bold', fontSize: '11pt' }}>3rd Party Data Sharing</div>
            <div style={{ fontWeight: 'bold', fontSize: '18pt' }}>My Linked 3rd Party Apps</div>
            <hr />
            <div className='DS-Text DS-Flex-Spread'><div>Here is a list of the previous and current health applications connections.</div><div className={`DS-Refresh${this.state.isRefreshing ? ' All-Spin' : ''}`} onClick={() => this.handleRefresh()}><TfiReload /></div></div>
            <div className='DS-Row DS-Table-Header DS-Flex'>
                <div style={{ width: '170px', padding: '5px' }}>Application</div>
                <div style={{ width: '170px', padding: '5px' }}>Requestor</div>
                <div style={{ width: '130px', padding: '5px' }}>Status</div>
                <div style={{ width: '200px', padding: '5px' }}>Date</div>
            </div>
            {this.state.apps.map((a, aidx) => {
                return <div key={`hist-${aidx}`} className='DS-Row DS-Table-Row DS-Flex'>
                    <div style={{ width: '170px', padding: '5px' }}>{a.app}</div>
                    <div style={{ width: '170px', padding: '5px' }}>{a.requestor}</div>
                    <div style={{ width: '130px', padding: '5px' }}>{a.active ? 'Active' : 'Inactive'}</div>
                    <div style={{ width: '200px', padding: '5px' }}>{moment(a.date).format('lll')}</div>
                    {a.active && <div className='DS-Button' onClick={() => this.handleCancelApp(a.app)}>Revoke</div>}
                </div>
            })}
        </div>
    }

    getSplash() {
        return <div className='All-Splash'>
            <img src={Logo} className='All-Logo' alt="HIT FHIR" />
        </div>
    }

    getBounce() {
        return <div className='All-Bounce'>
            <img src={Logo} className='All-Logo' alt="HIT FHIR" />
            <div className='All-Content'>Become part of Interoperability by Logging In or Joining HIT FHIR.</div>
        </div>
    }

    getTopMenu() {
        switch (this.state.topMenu) {
            case 'settings':
                return <div className='DS-Top-SubMenu' onClick={() => this.handleCloseTopMenu()}>
                    <div className='DS-Top-Menu-Category'>Contrast Accessibility</div>
                    <div className='DS-Top-Menu-Option'>High Contrast</div>
                    <div className='DS-Top-Menu-Option'>Normal Contrast</div>
                    <div className='DS-Top-Menu-Option' style={{ textDecoration: 'underline', color: '#2fa3d9' }}>Low Contrast</div>
                    <div className='DS-Top-Menu-Category'>Animation Control</div>
                    <div className='DS-Top-Menu-Option' style={{ textDecoration: 'underline', color: '#2fa3d9' }}>Turn Off Animations</div>
                    <div className='DS-Top-Menu-Category'>Contact & Help</div>
                    <div className='DS-Top-Menu-Option' style={{ textDecoration: 'underline', color: '#2fa3d9' }}>Contact Us</div>
                </div>
            case 'myplan':
                return <div className='DS-Mid-SubMenu'>
                    <div className='DS-Flex-Wrap'>
                        <div>
                            <div className='DS-Top-Menu-Category'>Costs & Financials</div>
                            <div className='DS-Top-Menu-Option'>Savings Accounts & Rebates</div>
                            <div className='DS-Top-Menu-Option'>Compare Prescription Costs</div>
                            <div className='DS-Top-Menu-Option'>Medical Cost Ranges</div>
                            <div className='DS-Top-Menu-Option'>My Health Statements</div>
                            <div className='DS-Top-Menu-Option'>Blue365 Discount Programs</div>
                        </div>
                        <div>
                            <div className='DS-Top-Menu-Category'>Coverage</div>
                            <div className='DS-Top-Menu-Option'>Coverage Breakdown</div>
                            <div className='DS-Top-Menu-Option'>Plan Use</div>
                            <div className='DS-Top-Menu-Option'>Pharmacy Resources</div>
                            <div className='DS-Top-Menu-Option'>Documents & Forms</div>
                        </div>
                    </div>
                </div>
            case 'myclaims':
                return <div className='DS-Mid-SubMenu'>
                    <div className='DS-Flex-Wrap'>
                        <div>
                            <div className='DS-Top-Menu-Category'>Claims</div>
                            <div className='DS-Top-Menu-Option'>My Claims</div>
                            <div className='DS-Top-Menu-Option'>Submit a Claim</div>
                        </div>
                        <div>
                            <div className='DS-Top-Menu-Category'>Appeals</div>
                            <div className='DS-Top-Menu-Option'>My Appeals</div>
                            <div className='DS-Top-Menu-Option'>Submit an Appeal</div>
                        </div>
                        <div>
                            <div className='DS-Top-Menu-Category'>Authorizations</div>
                            <div className='DS-Top-Menu-Option'>My Authorizations</div>
                            <div className='DS-Top-Menu-Option'>Preapproved Authorizations</div>
                        </div>
                    </div>
                </div>
            case 'findcare':
                return <div className='DS-Mid-SubMenu'>
                    <div className='DS-Flex-Wrap'>
                        <div>
                            <div className='DS-Top-Menu-Category'>Find Care</div>
                            <div className='DS-Top-Menu-Option'>Find a Doctor & More</div>
                        </div>
                        <div>
                            <div className='DS-Top-Menu-Category'>Get Care</div>
                            <div className='DS-Top-Menu-Option'>My Care Team</div>
                            <div className='DS-Top-Menu-Option'>Connect with Care Programs & Resources</div>
                            <div className='DS-Top-Menu-Option'>Better You Strides</div>
                        </div>
                    </div>
                </div>
            default:
                return null
        }
    }

    render() {
        //console.log(this.props, this.state)
        //console.log(window.innerWidth)
        return <div className='DS-Container'>
            <div className='DS-Row DS-Flex-Spread DS-Top-Menu'>
                <div className='DS-Flex'>
                    <div>
                        <div className={`DS-Flex${this.state.topMenu === 'settings' ? ' DS-Top-SubMenu-Selected' : ''}`} style={{ borderRight: '2px solid #4f4d4d', paddingRight: '5px', cursor: 'pointer' }} onClick={() => this.handleTopMenu('settings')}>
                            <div style={{ marginRight: '5px', fontSize: '16pt' }}><CiSettings /></div>
                            <div style={{ fontSize: '10pt', marginTop: '4px' }}><FaChevronDown /></div>
                        </div>
                        {this.state.topMenu === 'settings' && this.getTopMenu()}
                    </div>
                    <div style={{ paddingLeft: '5px' }}>
                        <div className='DS-Flex'>
                            <div>Espanol</div>
                        </div>
                    </div>
                </div>
                <div className='DS-Flex'>
                    <div>
                        <div className='DS-Flex' style={{ borderRight: '2px solid #4f4d4d', paddingRight: '5px' }}>
                            <div style={{ marginRight: '5px' }}><FaRegQuestionCircle /></div>
                            <div>Help</div>
                        </div>
                    </div>
                    <div style={{ paddingLeft: '5px' }}>
                        <div className='DS-Flex'>
                            <div style={{ marginRight: '5px' }}><LuLogOut /></div>
                            <div>Log out</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='DS-Row DS-Flex-Spread DS-Top-Menu-2'>
                <div className='DS-Logo'><div style={{ marginTop: '-2px' }} className='DS-Flex-Wrap'><FaSignature /><FaBuildingShield /></div></div>
                {window.innerWidth > 400 ? <div className='DS-Flex-Spread DS-Top-Menue-Middle'>
                    <div className={`DS-Flex${this.state.topMenu === 'myplan' ? ' DS-Top-SubMenu-Selected' : ''}`} style={{ paddingTop: '7px', marginRight: '10px', cursor: 'pointer' }} onClick={() => this.handleTopMenu('myplan')}>
                        <div style={{ marginRight: '5px' }}>My Plan</div>
                        <div style={{ fontSize: '10pt', marginTop: '4px' }}><FaChevronDown /></div>
                    </div>
                    <div className={`DS-Flex${this.state.topMenu === 'myclaims' ? ' DS-Top-SubMenu-Selected' : ''}`} style={{ paddingTop: '7px', marginRight: '10px', cursor: 'pointer' }} onClick={() => this.handleTopMenu('myclaims')}>
                        <div style={{ marginRight: '5px' }}>My Claims</div>
                        <div style={{ fontSize: '10pt', marginTop: '4px' }}><FaChevronDown /></div>
                    </div>
                    <div className='DS-Flex' style={{ paddingTop: '7px', marginRight: '10px' }}>
                        <div style={{ marginRight: '5px' }}>My Rewards</div>
                        <div style={{ fontSize: '10pt', marginTop: '4px' }}><FaChevronDown /></div>
                    </div>
                    <div className={`DS-Flex${this.state.topMenu === 'findcare' ? ' DS-Top-SubMenu-Selected' : ''}`} style={{ paddingTop: '7px', marginRight: '10px', cursor: 'pointer' }} onClick={() => this.handleTopMenu('findcare')}>
                        <div style={{ marginRight: '5px' }}>Find & Get Care</div>
                        <div style={{ fontSize: '10pt', marginTop: '4px' }}><FaChevronDown /></div>
                    </div>
                </div> : null}
                {this.state.topMenu === 'myplan' && this.getTopMenu()}
                {this.state.topMenu === 'myclaims' && this.getTopMenu()}
                {this.state.topMenu === 'findcare' && this.getTopMenu()}
                {this.state.displayMsg && this.getMessage()}
                <div>
                    <div className='DS-Flex' style={{ paddingTop: '0px' }}>
                        <div className='DS-Flex' style={{ borderRight: '2px solid #4f4d4d', paddingRight: '5px' }}>
                            <div className='DS-Top-Menu-Item' style={{ paddingRight: '5px' }}>
                                <div style={{ marginRight: '5px' }}><FaRegEnvelope /></div>
                                <div style={{ fontSize: '8pt' }}>Messages</div>
                            </div>
                            <div className='DS-Top-Menu-Item' style={{ paddingRight: '5px' }}>
                                <div style={{ marginRight: '5px' }}><FaRegIdCard /></div>
                                <div style={{ fontSize: '8pt' }}>ID Card</div>
                            </div>
                        </div>
                        <div style={{ paddingLeft: '5px' }} className='DS-Flex'>
                            <div style={{ marginRight: '5px' }}>
                                <div style={{ fontWeight: 'bold' }}>{this.props.user ? `${this.props.user.firstName + ' ' || ''}${this.props.user.lastName || ''}` : 'Member Name'}</div>
                                <div style={{ fontSize: '8pt' }}>{this.props.user ? `${this.props.user.healthIns && this.props.user.healthIns.plan ? (this.props.user.healthIns.plan.length > 25 ? `${this.props.user.healthIns.plan.substring(0, 22)}...` : this.props.user.healthIns.plan) : 'Member Plan'}` : 'Member Plan'}</div>
                            </div>
                            <div style={{ fontSize: '10pt', marginTop: '4px' }}><FaChevronDown /></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='DS-Row DS-Flex'>
                <div className='DS-Left-Column'>
                    <div className='DS-Menu-Item DS-Flex' onClick={() => this.handleNavigate('', false)}>
                        <div style={{ marginRight: '5px' }}><FaArrowLeft /></div>
                        <div>My Account</div>
                    </div>
                    <div className={`DS-Menu-Item DS-Flex${this.state.menu === 'Apps' ? ' DS-Menu-Item-Selected' : ''}`} onClick={() => this.handleMenuSelected('Apps')}>
                        <div>Third Party Apps</div>
                    </div>
                    <div className={`DS-Menu-Item DS-Flex${this.state.menu === 'Insurers' ? ' DS-Menu-Item-Selected' : ''}`} onClick={() => this.handleMenuSelected('Insurers')}>
                        <div>Other Health Insurers</div>
                    </div>
                    <div className={`DS-Menu-Item DS-Flex${this.state.menu === 'Provider' ? ' DS-Menu-Item-Selected' : ''}`} onClick={() => this.handleMenuSelected('Provider')}>
                        <div>Provider Data Access</div>
                    </div>
                </div>
                <div className='DS-Right-Column'>
                    {this.state.menu === 'Apps' && this.getApps()}
                    {this.state.menu === 'Insurers' && this.getInsurers()}
                    {this.state.menu === 'Payers' && this.getPayers()}
                    {this.state.menu === 'Linked Payers' && this.getLinkedInsurance()}
                    {this.state.menu === 'Provider' && this.getProvider()}
                </div>
            </div>
        </div>
    }

}
export default withRouter(DataSharing)